import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import ForgotPassword from "@/features/auth/forgot-password";
import Login from "@/features/auth/login";
import Signup from "@/features/auth/signup";
import NotFound from "@/features/not-found";

// Route-level splitting: each surface pays only for itself.
const Feedback = React.lazy(() => import("@/features/feedback"));
const Home = React.lazy(() => import("@/features/home"));
const LandingPage = React.lazy(() => import("@/features/landing"));
const Settings = React.lazy(() => import("@/features/settings"));
import PrivateRoute from "@/app/routes/components/private-route";
import { Spinner } from "@/ui";

function RouteManager() {
  function lazyWithPreload(factory: any) {
    const Component: any = React.lazy(factory);
    Component.preload = factory;
    return Component;
  }

  const LazyWorkout = lazyWithPreload(() => import("@/features/workout"));
  LazyWorkout.preload();

  const Fallback = (
    <div className="w-full h-full flex items-center justify-center">
      <Spinner aria-label="Loading" size="xl" />
    </div>
  );
  return (
    <React.Suspense fallback={Fallback}>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/feedback"
          element={
            <PrivateRoute>
              <Feedback />
            </PrivateRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />
        <Route path="/" element={<LandingPage />} />
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/workouts/:workoutId"
          element={
            <PrivateRoute>
              <LazyWorkout />
            </PrivateRoute>
          }
        />
        {/* The old carousel page — its job moved to /home */}
        <Route path="/workouts/" element={<Navigate to="/home" replace />} />
      </Routes>
    </React.Suspense>
  );
}

export default RouteManager;
